// extracted by mini-css-extract-plugin
export default {"__appMain__":"app___appMain____-DqNA"};